import { useSubcuratorsQuery } from "@src/queries/curatorQueries";
import { IGuestCuratorRecord } from "@src/types/curator";
import { RoleType } from "@src/types/user";

interface UseMyCuratorsResult {
  myCurators: IGuestCuratorRecord[];
  fetchingMyCurators: boolean;
  fetchingMyCuratorsError: any;
  refetchMyCurators: () => void;
}

export const useMyCurators = (
  parentCuratorId: string,
  searchText?: string,
  roleType?: RoleType,
  options?: { enabled?: boolean }
): UseMyCuratorsResult => {
  const { data, isLoading, error, refetch } = useSubcuratorsQuery(
    parentCuratorId,
    searchText,
    roleType,
    options
  );
  return {
    myCurators: data?.data?.data || [],
    fetchingMyCurators: isLoading,
    fetchingMyCuratorsError: error,
    refetchMyCurators: refetch,
  };
};
